import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { DiscardAggregate } from '../../_models/discard-aggregate';
import { DiscardAggregateFilter } from '../../_models/discard-aggregate';
import { DiscardAggregateService } from '../../_services/discard-aggregate.service';
import { DiscardImportedService } from 'app/_services/discard-imported.service';
import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-discards-list',
  templateUrl: './discards-list.component.html',
  styleUrls: ['./discards-list.component.sass'],
})
export class DiscardsListComponent extends List implements OnInit {
  errorMessage: string;
  involved_years: string[] = [];
  filter: DiscardAggregateFilter = new DiscardAggregateFilter();
  public profile: Profile;
  loading: boolean;

  constructor(
    private discardAggregateService: DiscardAggregateService,
    private discardImportedService: DiscardImportedService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(discardAggregateService, new DiscardAggregate(), router, route);
    this.loading = false;
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.route.params.subscribe((routeParams) => {
      this.loading = true;
      if (this.profile.haveAccess('import')) {
        if (this.filter) {
          let newService = this.service;
          if (routeParams['data_type']) {
            if (routeParams['data_type'] === 'dea') {
              newService = this.discardAggregateService;
            } else if (routeParams['data_type'] === 'imports') {
              newService = this.discardImportedService;
            }
          }
          if (newService !== this.service) {
            this.service = newService;
          }
        }
      }
    });
  }

  ngOnInit() {
    this.pageSize = 10000;
    this.initList('discards', this.filter);
  }

  listCallback() {
    this.involved_years = [];
    if (this.collection.length > 0) {
      const totals = this.collection[0].totals;
      for (const total of totals) {
        this.involved_years.push(total['year']);
      }
    }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/discards/discards-list/discards-list.component.ts